import { Observable } from 'rxjs';

export function resizeObservable(element: HTMLElement) {
  return new Observable(subscriber => {
    const observer = new ResizeObserver(entries => {
      subscriber.next(entries);
    });

    observer.observe(element);

    return function unsubscribe() {
      observer.unobserve(element);
    }
  });
}

export function searchElementUpwards(sourceElement: HTMLElement, selector: string): HTMLElement | undefined {
  const element = sourceElement.parentElement.querySelector<HTMLElement>(selector);
  return element ?? searchElementUpwards(sourceElement.parentElement.parentElement, selector);
}
